/*
 * @Author: YuanYuan
 * @Date: 2025-07-22 16:18:20
 * @LastEditTime: 2025-09-19 09:20:31
 * @Description: 用来定义在utils/hooks中的接口
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'domainGroupList',
    path: `${prefix}/domainGroup/list`,
    method: 'post',
    params: {
      groupName: '',
      domains: ''
    },
    desc: '域名组'
  },
  {
    name: 'packageGetAllId',
    path: `${prefix}/package/getAllId`,
    method: 'get',
    params: {},
    desc: '客户套餐列表'
  },
  {
    name: 'getTransClientList',
    path: `${prefix}/user/getTransClientList`,
    method: 'get',
    params: {
      conditions: '',
      username: ''
    },
    desc: '获取渠道商账户列表'
  },
  {
    name: 'allBasePackage',
    path: `${prefix}/package/getAllBaseInfo`,
    method: 'get',
    params: {},
    desc: '套餐相关-获取所有套餐规格'
  },
  {
    name: 'getPackagePrice',
    path: `${prefix}/package/getPackagePrice`,
    method: 'get',
    params: {},
    desc: '套餐相关-获取所有套餐定价'
  },
  {
    name: 'getPackageDetail',
    path: `${prefix}/package/getPackageDetail`,
    method: 'get',
    params: {
      packageId: ''
    },
    desc: '套餐相关-获取单个套餐详情'
  }
]
